import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { User } from '@models/Core/User';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchService } from '@services/search.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-add-participant-modal',
  templateUrl: './add-participant-modal.component.html',
  styleUrls: ['./add-participant-modal.component.scss'],
})
export class AddParticipantModalComponent implements OnInit, OnDestroy {
  @Input() session: Session;

  suggestions: User[];
  selected: User;

  input = new Subject<string>();
  sub = new Subscription();

  constructor(
    private activeModal: NgbActiveModal,
    private search: SearchService,
  ) {}

  ngOnInit() {
    this.sub = this.input
      .pipe(
        debounceTime(500),
        switchMap(query => this.search.search(query)),
      )
      .subscribe((result: any) => {
        if (result.users && result.users.length > 0) {
          this.suggestions = result.users
            .map(entry => entry.user)
            .filter(
              u =>
                !this.session.config.participants.some(
                  p =>
                    p && p.user && p.user._id.toString() === u._id.toString(),
                ),
            );
          this.selected = undefined;
        } else {
          this.suggestions = [];
          this.selected = undefined;
        }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onKey(value: string) {
    this.input.next(value);
  }

  onSelect(user) {
    this.selected = user;
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  closeAndAddParticipant() {
    this.activeModal.close(this.selected);
  }
}
